import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateService } from '../services/create.service';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent {

  displayedColumns: string[] = ['dateTime', 'logName', 'objectName'];
  dataSource = new MatTableDataSource<any>([]);
  logs: any = [];
  userEmailId = this.storage.retrieve("userEmailId");

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private storage: LocalStorageService, private toastr: ToastrService, private createService: CreateService) {

  }

  ngOnInit() {
    this.createService.getAuditLogs(this.userEmailId).subscribe({
      next: (data: any) => {
        console.log(data);
        this.logs = data;
        this.dataSource = new MatTableDataSource<any>(data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: (e: any) => {

      }
    })

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
